export const SET_PRODUCTS = 'ELIGIBILITY_ENGINE/SET_PRODUCTS';
export const SET_PRODUCTS_LOADING = 'ELIGIBILITY_ENGINE/SET_PRODUCTS_LOADING';
export const SET_PRODUCTS_ERROR = 'ELIGIBILITY_ENGINE/SET_PRODUCTS_ERROR';
export const SET_SELECTED_PRODUCT = 'ELIGIBILITY_ENGINE/SET_SELECTED_PRODUCT';
export const SET_RULES = 'ELIGIBILITY_ENGINE/SET_RULES';
export const SET_RULES_LOADING = 'ELIGIBILITY_ENGINE/SET_RULES_LOADING';
export const SET_RULES_ERROR = 'ELIGIBILITY_ENGINE/SET_RULES_ERROR';
export const SET_HAS_UNSAVED_CHANGES = 'ELIGIBILITY_ENGINE/SET_HAS_UNSAVED_CHANGES';
export const UPDATE_RULE = 'ELIGIBILITY_ENGINE/UPDATE_RULE';
export const SET_PENDING_ACTIVATION = 'ELIGIBILITY_ENGINE/SET_PENDING_ACTIVATION';
export const SET_NEXT_EFFECTIVE_FROM = 'ELIGIBILITY_ENGINE/SET_NEXT_EFFECTIVE_FROM';
export const ADD_RULE = 'ELIGIBILITY_ENGINE/ADD_RULE';
export const ADD_RULE_SORTED = 'ELIGIBILITY_ENGINE/ADD_RULE_SORTED';
export const REMOVE_RULE = 'ELIGIBILITY_ENGINE/REMOVE_RULE';
